// extracted by mini-css-extract-plugin
export default {"publication":"publication_publication__RQeKs","post":"publication_post__uw-hQ"};